'use client'

import { useLocale } from 'next-intl'

import { resolveCryptoNumberLocale } from './numberLocale'

/**
 * Política dos NÚMEROS de cripto por locale (preço, %, market cap, volume, bolhas, oferta): ficam em
 * pt-BR (1.234,56) para pt/en/es/it/fr/ja — coerente com o símbolo US$ fixo, evita mistura na tabela —
 * EXCETO nos locais de `CRYPTO_NUMBER_LOCALE_LOCALES` (hoje: zh-CN), que seguem o próprio locale
 * (padrão CoinDesk: 1,234.56 + 万/亿). Único ponto de controle: `resolveCryptoNumberLocale`
 * (`numberLocale.ts`). Ver decisão do dono 2026-07-06.
 *
 * Hook CLIENT: use em componentes `'use client'` que chamam as funções de formatação de preço/número
 * e passe o retorno como argumento `locale`. Em SERVER usar
 * `resolveCryptoNumberLocale(await getRequestLocale())`.
 */
export function useNumberLocale(): string {
  return resolveCryptoNumberLocale(useLocale())
}
